var _defs, _path, _g, _g2, _g3, _path2, _path3, _path4, _path5, _rect, _rect2, _circle, _circle2, _g4, _circle3, _circle4, _circle5, _rect3, _rect4, _rect5, _rect6, _rect7, _g5, _path6, _circle6, _g6, _rect8, _rect9, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _g24, _g25, _g26, _g27, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _g28, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "7d8641e0-c257-4791-b312-86d1704443b9",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080.96,
    height: 836.7,
    viewBox: "0 0 1080.96 836.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "125bba2f-f569-40b7-bd66-d57fb0c1ec70",
    x1: 522.67,
    y1: 796.03,
    x2: 522.67,
    y2: 67.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "56fd5fc2-5801-467f-a895-372693779337",
    x1: 950.39,
    y1: 837.64,
    x2: 950.39,
    y2: 177.91,
    xlinkHref: "#125bba2f-f569-40b7-bd66-d57fb0c1ec70"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "report") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M293.94,32.28C259.18,31,222.87,30.1,191.44,45s-55.73,51-45.19,84.19c3.44,10.82,10.14,20.25,15.79,30.1,28.25,49.26,29.56,112.93,3.37,163.32-20.16,38.79-54.33,68.31-78.93,104.45S47.9,513.29,72.1,549.7c16.57,24.93,47.32,37.06,77.11,40s59.75-1.69,89.67-2.88a386.25,386.25,0,0,1,169.58,32.07c73.49,32.22,136.8,87.34,214.18,108.61,9.29,2.55,19,4.61,28.5,2.88,16.85-3.07,29.1-17,42.29-28,42.11-34.87,100.41-41.38,155.07-43s111.59-.37,161-23.84c43.14-20.49,76.35-58.61,97-101.67s29.62-90.91,33-138.56c2-28.36,1.93-57.64-8.22-84.19-11.41-29.85-34.55-53.62-58.82-74.4-25.36-21.72-53-41.4-84.31-53.12-37.4-14-78-16-117.82-19.32a1618.5,1618.5,0,0,1-242.36-38.92C552.34,107.28,469.3,87.53,400.42,50.7,365.85,32.21,332.91,33.68,293.94,32.28Z",
    transform: "translate(-59.52 -31.65)",
    fill: "#009ddd",
    opacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M773.4,661.32s3.54-49.61,31.46-76.66a75.33,75.33,0,0,0,22.26-42.15,127.38,127.38,0,0,0,1.5-23.13",
    transform: "translate(-59.52 -31.65)",
    fill: "#009ddd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M846.11,502.23c-2.05,5.48-17.9,17.66-17.9,17.66s-4-19.59-1.93-25.07a10.58,10.58,0,0,1,19.83,7.41Z",
    transform: "translate(-59.52 -31.65)",
    fill: "#009ddd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M851.17,538.7c-4.7,3.48-24.62,5.09-24.62,5.09s7.3-18.61,12-22.1a10.59,10.59,0,0,1,12.62,17Z",
    transform: "translate(-59.52 -31.65)",
    fill: "#009ddd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.08,590.27c-5.82.64-23.83-8-23.83-8s15.7-12.38,21.51-13a10.58,10.58,0,0,1,2.32,21Z",
    transform: "translate(-59.52 -31.65)",
    fill: "#009ddd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.09,625.87c-5.62,1.61-24.84-3.89-24.84-3.89s13.38-14.85,19-16.46a10.59,10.59,0,1,1,5.84,20.35Z",
    transform: "translate(-59.52 -31.65)",
    fill: "#009ddd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805.33,537.07c2.5,5.28,19.32,16.07,19.32,16.07s2.32-19.85-.19-25.14a10.59,10.59,0,0,0-19.13,9.07Z",
    transform: "translate(-59.52 -31.65)",
    fill: "#009ddd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M777.8,579.06c4,4.29,23.25,9.56,23.25,9.56s-3.73-19.64-7.7-23.94a10.59,10.59,0,0,0-15.55,14.38Z",
    transform: "translate(-59.52 -31.65)",
    fill: "#009ddd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.65,623.54c3.18,4.9,21.3,13.35,21.3,13.35s-.36-20-3.55-24.89a10.59,10.59,0,0,0-17.75,11.54Z",
    transform: "translate(-59.52 -31.65)",
    fill: "#009ddd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M846.11,502.23c-2.05,5.48-17.9,17.66-17.9,17.66s-4-19.59-1.93-25.07a10.58,10.58,0,0,1,19.83,7.41Z",
    transform: "translate(-59.52 -31.65)",
    fill: "#009ddd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M851.17,538.7c-4.7,3.48-24.62,5.09-24.62,5.09s7.3-18.61,12-22.1a10.59,10.59,0,0,1,12.62,17Z",
    transform: "translate(-59.52 -31.65)",
    fill: "#009ddd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.08,590.27c-5.82.64-23.83-8-23.83-8s15.7-12.38,21.51-13a10.58,10.58,0,0,1,2.32,21Z",
    transform: "translate(-59.52 -31.65)",
    fill: "#009ddd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.09,625.87c-5.62,1.61-24.84-3.89-24.84-3.89s13.38-14.85,19-16.46a10.59,10.59,0,1,1,5.84,20.35Z",
    transform: "translate(-59.52 -31.65)",
    fill: "#009ddd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805.33,537.07c2.5,5.28,19.32,16.07,19.32,16.07s2.32-19.85-.19-25.14a10.59,10.59,0,0,0-19.13,9.07Z",
    transform: "translate(-59.52 -31.65)",
    fill: "#009ddd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M777.8,579.06c4,4.29,23.25,9.56,23.25,9.56s-3.73-19.64-7.7-23.94a10.59,10.59,0,0,0-15.55,14.38Z",
    transform: "translate(-59.52 -31.65)",
    fill: "#009ddd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.65,623.54c3.18,4.9,21.3,13.35,21.3,13.35s-.36-20-3.55-24.89a10.59,10.59,0,0,0-17.75,11.54Z",
    transform: "translate(-59.52 -31.65)",
    fill: "#009ddd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M783.2,473.54s3.54-49.61,31.46-76.66a75.4,75.4,0,0,0,22.26-42.15,125.67,125.67,0,0,0,1.5-23.13",
    transform: "translate(-59.52 -31.65)",
    fill: "#009ddd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M855.91,314.45c-2,5.47-17.89,17.65-17.89,17.65s-4-19.59-1.94-25.06a10.58,10.58,0,1,1,19.83,7.41Z",
    transform: "translate(-59.52 -31.65)",
    fill: "#009ddd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M861,350.91c-4.69,3.49-24.62,5.09-24.62,5.09s7.3-18.6,12-22.09a10.59,10.59,0,1,1,12.62,17Z",
    transform: "translate(-59.52 -31.65)",
    fill: "#009ddd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M840.88,402.49c-5.81.64-23.82-8-23.82-8s15.7-12.37,21.51-13a10.59,10.59,0,1,1,2.31,21.05Z",
    transform: "translate(-59.52 -31.65)",
    fill: "#009ddd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M816.89,438.09c-5.62,1.61-24.84-3.89-24.84-3.89s13.39-14.85,19-16.47a10.59,10.59,0,0,1,5.83,20.36Z",
    transform: "translate(-59.52 -31.65)",
    fill: "#009ddd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.13,349.28c2.5,5.29,19.33,16.08,19.33,16.08s2.31-19.86-.19-25.14a10.59,10.59,0,1,0-19.14,9.06Z",
    transform: "translate(-59.52 -31.65)",
    fill: "#009ddd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M787.6,391.27c4,4.3,23.26,9.56,23.26,9.56s-3.74-19.64-7.71-23.93a10.59,10.59,0,0,0-15.55,14.37Z",
    transform: "translate(-59.52 -31.65)",
    fill: "#009ddd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.45,435.76c3.19,4.9,21.3,13.35,21.3,13.35s-.36-20-3.55-24.89a10.59,10.59,0,1,0-17.75,11.54Z",
    transform: "translate(-59.52 -31.65)",
    fill: "#009ddd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M855.91,314.45c-2,5.47-17.89,17.65-17.89,17.65s-4-19.59-1.94-25.06a10.58,10.58,0,1,1,19.83,7.41Z",
    transform: "translate(-59.52 -31.65)",
    fill: "#009ddd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M861,350.91c-4.69,3.49-24.62,5.09-24.62,5.09s7.3-18.6,12-22.09a10.59,10.59,0,1,1,12.62,17Z",
    transform: "translate(-59.52 -31.65)",
    fill: "#009ddd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M840.88,402.49c-5.81.64-23.82-8-23.82-8s15.7-12.37,21.51-13a10.59,10.59,0,1,1,2.31,21.05Z",
    transform: "translate(-59.52 -31.65)",
    fill: "#009ddd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M816.89,438.09c-5.62,1.61-24.84-3.89-24.84-3.89s13.39-14.85,19-16.47a10.59,10.59,0,0,1,5.83,20.36Z",
    transform: "translate(-59.52 -31.65)",
    fill: "#009ddd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.13,349.28c2.5,5.29,19.33,16.08,19.33,16.08s2.31-19.86-.19-25.14a10.59,10.59,0,1,0-19.14,9.06Z",
    transform: "translate(-59.52 -31.65)",
    fill: "#009ddd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M787.6,391.27c4,4.3,23.26,9.56,23.26,9.56s-3.74-19.64-7.71-23.93a10.59,10.59,0,0,0-15.55,14.37Z",
    transform: "translate(-59.52 -31.65)",
    fill: "#009ddd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.45,435.76c3.19,4.9,21.3,13.35,21.3,13.35s-.36-20-3.55-24.89a10.59,10.59,0,1,0-17.75,11.54Z",
    transform: "translate(-59.52 -31.65)",
    fill: "#009ddd"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.71,538.54S210,513.08,198.37,476a75.26,75.26,0,0,0-27.64-38.83,126.09,126.09,0,0,0-20-11.74",
    transform: "translate(-59.52 -31.65)",
    fill: "#009ddd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.28,402.07c4,4.29,7.73,23.93,7.73,23.93s-19.29-5.25-23.26-9.54a10.59,10.59,0,0,1,15.53-14.39Z",
    transform: "translate(-59.52 -31.65)",
    fill: "#009ddd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.13,414c1,5.76-6.52,24.28-6.52,24.28s-13.34-14.89-14.34-20.65A10.59,10.59,0,1,1,178.13,414Z",
    transform: "translate(-59.52 -31.65)",
    fill: "#009ddd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.17,455.08c-2,5.48-17.89,17.67-17.89,17.67s-4-19.59-1.95-25.06a10.59,10.59,0,1,1,19.84,7.39Z",
    transform: "translate(-59.52 -31.65)",
    fill: "#009ddd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.18,492.51C235.1,498.26,221.54,513,221.54,513s-7.25-18.63-6.16-24.37a10.58,10.58,0,1,1,20.8,3.93Z",
    transform: "translate(-59.52 -31.65)",
    fill: "#009ddd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.07,454.16c5.84.14,23.05-10,23.05-10s-16.7-11-22.55-11.14a10.59,10.59,0,0,0-.5,21.17Z",
    transform: "translate(-59.52 -31.65)",
    fill: "#009ddd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.2,497.63c5.62-1.62,19-16.48,19-16.48s-19.22-5.49-24.84-3.87a10.59,10.59,0,0,0,5.85,20.35Z",
    transform: "translate(-59.52 -31.65)",
    fill: "#009ddd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.42,536.52c5.82-.64,21.51-13,21.51-13s-18-8.66-23.83-8a10.58,10.58,0,1,0,2.32,21Z",
    transform: "translate(-59.52 -31.65)",
    fill: "#009ddd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.28,402.07c4,4.29,7.73,23.93,7.73,23.93s-19.29-5.25-23.26-9.54a10.59,10.59,0,0,1,15.53-14.39Z",
    transform: "translate(-59.52 -31.65)",
    fill: "#009ddd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.13,414c1,5.76-6.52,24.28-6.52,24.28s-13.34-14.89-14.34-20.65A10.59,10.59,0,1,1,178.13,414Z",
    transform: "translate(-59.52 -31.65)",
    fill: "#009ddd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.17,455.08c-2,5.48-17.89,17.67-17.89,17.67s-4-19.59-1.95-25.06a10.59,10.59,0,1,1,19.84,7.39Z",
    transform: "translate(-59.52 -31.65)",
    fill: "#009ddd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.18,492.51C235.1,498.26,221.54,513,221.54,513s-7.25-18.63-6.16-24.37a10.58,10.58,0,1,1,20.8,3.93Z",
    transform: "translate(-59.52 -31.65)",
    fill: "#009ddd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.07,454.16c5.84.14,23.05-10,23.05-10s-16.7-11-22.55-11.14a10.59,10.59,0,0,0-.5,21.17Z",
    transform: "translate(-59.52 -31.65)",
    fill: "#009ddd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.2,497.63c5.62-1.62,19-16.48,19-16.48s-19.22-5.49-24.84-3.87a10.59,10.59,0,0,0,5.85,20.35Z",
    transform: "translate(-59.52 -31.65)",
    fill: "#009ddd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.42,536.52c5.82-.64,21.51-13,21.51-13s-18-8.66-23.83-8a10.58,10.58,0,1,0,2.32,21Z",
    transform: "translate(-59.52 -31.65)",
    fill: "#009ddd"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M776.25,838c28.71,12.49,63.74,4.89,96.32,5.77,4.45.12,9.18.49,12.75,2.65s5.34,5.65,7.79,8.65c9.13,11.14,27.84,14.72,44.19,12.83s31.34-8.15,46.77-12.91c26.67-8.24,57.15-12,83.46-3,2.41.82,5,1.77,7.54,1.44,5.77-.73,7.49-6.71,11.52-10.12,7.28-6.17,23.1-4.49,26.3-12.62,1.87-4.76-2.44-9.64-7.14-12.89-18-12.44-43.7-14.49-67.23-12.57s-46.66,7.21-70.31,7.23c-29.47,0-57.94-8.12-87.12-11.45-20.21-2.3-42.27-2-61.22,4.77C799.33,813.1,794.81,829.59,776.25,838Z",
    transform: "translate(-59.52 -31.65)",
    fill: "#009ddd",
    opacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M232.93,799.69c49,14.11,108.8,5.52,164.4,6.52,7.61.14,15.67.55,21.78,3s9.11,6.4,13.3,9.78c15.58,12.59,47.51,16.64,75.41,14.5s53.5-9.21,79.84-14.59c45.52-9.31,97.56-13.55,142.46-3.4,4.12.93,8.46,2,12.88,1.63,9.84-.83,12.77-7.58,19.66-11.44,12.43-7,39.42-5.07,44.88-14.25,3.2-5.38-4.16-10.9-12.18-14.57-30.68-14.05-74.58-16.37-114.75-14.2s-79.65,8.14-120,8.17c-50.3,0-98.9-9.17-148.71-12.94-34.5-2.6-72.15-2.28-104.5,5.4C272.33,771.59,264.6,790.22,232.93,799.69Z",
    transform: "translate(-59.52 -31.65)",
    fill: "#009ddd",
    opacity: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M101.77,834.27c14,8.42,31,3.3,46.86,3.89,2.17.08,4.47.33,6.21,1.78s2.6,3.82,3.79,5.84c4.44,7.51,13.54,9.93,21.49,8.65s15.25-5.49,22.76-8.71c13-5.55,27.81-8.08,40.6-2a6.38,6.38,0,0,0,3.68,1c2.8-.5,3.64-4.53,5.6-6.83,3.54-4.16,11.24-3,12.79-8.51.91-3.21-1.19-6.5-3.47-8.69-8.74-8.39-21.26-9.77-32.71-8.48S206.67,817,195.16,817c-14.33,0-28.18-5.47-42.38-7.72-9.84-1.56-20.57-1.36-29.79,3.22C113,817.5,110.8,828.62,101.77,834.27Z",
    transform: "translate(-59.52 -31.65)",
    fill: "#009ddd",
    opacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M755,67.32H290.38a42.55,42.55,0,0,0-42.62,42.49V753.54A42.55,42.55,0,0,0,290.38,796H755a42.55,42.55,0,0,0,42.62-42.49V109.81A42.55,42.55,0,0,0,755,67.32Z",
    transform: "translate(-59.52 -31.65)",
    fill: "url(#125bba2f-f569-40b7-bd66-d57fb0c1ec70)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 194.79,
    y: 44.4,
    width: 536.72,
    height: 713.44,
    rx: 20,
    ry: 20,
    fill: "#535461"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 222.06,
    y: 111.88,
    width: 482.18,
    height: 578.47,
    fill: "#f6f7f9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 460.97,
    cy: 77.12,
    r: 6.55,
    fill: "#f6f7f9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 460.97,
    cy: 722.93,
    r: 19.64,
    fill: "#f6f7f9"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 222.06,
    y: 111.88,
    width: 482.18,
    height: 28.83,
    fill: "#009ddd"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 237.14,
    cy: 126.3,
    r: 6.15,
    fill: "#f6f7f9"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 252.81,
    cy: 126.3,
    r: 6.15,
    fill: "#f6f7f9"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 268.47,
    cy: 126.3,
    r: 6.15,
    fill: "#f6f7f9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 236.46,
    y: 281.93,
    width: 449.01,
    height: 1.5,
    fill: "#dce0ed"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 236.46,
    y: 316.76,
    width: 449.01,
    height: 1.5,
    fill: "#dce0ed"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 236.46,
    y: 351.6,
    width: 449.01,
    height: 1.5,
    fill: "#dce0ed"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 236.46,
    y: 386.43,
    width: 449.01,
    height: 1.5,
    fill: "#dce0ed"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 236.46,
    y: 421.26,
    width: 449.01,
    height: 1.5,
    fill: "#dce0ed"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "685.47 422.76 235.91 422.76 235.91 354.26 277.14 374.58 319.81 380.37 357.25 369.08 402.42 334.05 425.14 320.93 441.75 317.73 457.64 318.58 483.77 331.49 519.3 354.12 547.18 357.7 569.28 350.08 616.14 311.71 640.06 303.18 665.09 307.05 685.47 318.82 685.47 422.76",
    fill: "#009ddd"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M373.79,412c-40.49,0-77.9-24.76-78.37-25.08l1.12-1.66c.58.39,58.16,38.48,107.09,19.4,17.84-7,30.54-17.78,42.83-28.25,12.83-10.93,24.94-21.25,41.46-25.73,18.94-5.13,39.64-.49,55.37,12.44,13.45,11.05,40.23,28.79,68.52,23.49,14.42-2.71,26.57-13.24,39.44-24.39,24.67-21.38,50.19-43.49,94.33-11.77l-1.17,1.62c-42.86-30.8-67.76-9.21-91.85,11.66-13.08,11.33-25.43,22-40.38,24.84-29.1,5.46-56.44-12.64-70.16-23.91-15.23-12.51-35.25-17-53.58-12.05-16.08,4.36-28,14.54-40.69,25.32-12.41,10.58-25.24,21.51-43.39,28.59A83.72,83.72,0,0,1,373.79,412Z",
    transform: "translate(-59.52 -31.65)",
    fill: "#009ddd"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 452.52,
    cy: 317.63,
    r: 11.13,
    fill: "#009ddd"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M657.22,202H516.82a2.28,2.28,0,0,0-2.28,2.28v94.95a2.28,2.28,0,0,0,3.94,1.56l24.33-25.95a2.27,2.27,0,0,1,1.66-.72H657.22a2.28,2.28,0,0,0,2.28-2.28V204.26A2.28,2.28,0,0,0,657.22,202Z",
    transform: "translate(-59.52 -31.65)",
    fill: "#009ddd"
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 487.52,
    y: 187.93,
    width: 79.95,
    height: 10,
    fill: "#f6f7f9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 487.52,
    y: 210.09,
    width: 21.95,
    height: 10,
    fill: "#f6f7f9"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 274.38,
    y: 494.32,
    width: 21.95,
    height: 10,
    fill: "#009ddd"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 274.38,
    y: 513.65,
    width: 21.95,
    height: 10,
    fill: "#009ddd"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 274.38,
    y: 532.98,
    width: 21.95,
    height: 10,
    fill: "#009ddd"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 274.38,
    y: 552.32,
    width: 21.95,
    height: 10,
    fill: "#009ddd"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 274.38,
    y: 571.65,
    width: 21.95,
    height: 10,
    fill: "#009ddd"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 274.38,
    y: 590.98,
    width: 21.95,
    height: 10,
    fill: "#009ddd"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 274.38,
    y: 610.32,
    width: 21.95,
    height: 10,
    fill: "#009ddd"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 274.38,
    y: 629.65,
    width: 21.95,
    height: 10,
    fill: "#009ddd"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 315.71,
    y: 639.65,
    width: 21.95,
    height: 10,
    fill: "#009ddd"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 354.38,
    y: 639.65,
    width: 21.95,
    height: 10,
    fill: "#009ddd"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 393.05,
    y: 639.65,
    width: 21.95,
    height: 10,
    fill: "#009ddd"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 431.71,
    y: 639.65,
    width: 21.95,
    height: 10,
    fill: "#009ddd"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 470.38,
    y: 639.65,
    width: 21.95,
    height: 10,
    fill: "#009ddd"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 509.05,
    y: 639.65,
    width: 21.95,
    height: 10,
    fill: "#009ddd"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 547.71,
    y: 639.65,
    width: 21.95,
    height: 10,
    fill: "#009ddd"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 586.38,
    y: 639.65,
    width: 21.95,
    height: 10,
    fill: "#009ddd"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 625.05,
    y: 639.65,
    width: 21.95,
    height: 10,
    fill: "#009ddd"
  }))), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 534.14,
    y: 210.09,
    width: 33.33,
    height: 10,
    fill: "#f6f7f9"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 315.71,
    y: 566.98,
    width: 21.95,
    height: 62.67,
    fill: "#009ddd"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 354.38,
    y: 537.98,
    width: 21.95,
    height: 91.67,
    fill: "#009ddd"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 393.05,
    y: 513.65,
    width: 21.95,
    height: 116,
    fill: "#009ddd"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 431.71,
    y: 526.26,
    width: 21.95,
    height: 103.38,
    fill: "#009ddd"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 470.38,
    y: 504.32,
    width: 21.95,
    height: 125.33,
    fill: "#009ddd"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 509.05,
    y: 552.32,
    width: 21.95,
    height: 77.33,
    fill: "#009ddd"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 547.71,
    y: 552.32,
    width: 21.95,
    height: 77.33,
    fill: "#009ddd"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 586.38,
    y: 552.32,
    width: 21.95,
    height: 77.33,
    fill: "#009ddd"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 625.05,
    y: 552.32,
    width: 21.95,
    height: 77.33,
    fill: "#009ddd"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1049,304.15c-23.77-13.67-32.75-17.06-32.8-17.08l-.48-.35a19.86,19.86,0,0,1-6-7.57c0-.55,0-1.09,0-1.63v.16c.38-7.24,5.53-13.83,10.42-19.58l12.49-14.7a14.27,14.27,0,0,0,3.22-5.1,11.39,11.39,0,0,0,.34-3.13c0-.43,0-.86,0-1.28-.06-3.65-.17-7.31-.3-11-.12-3.19-.94-7.21-4.13-7.87-1.66-.34-3.85.26-4.73-1.17a2.72,2.72,0,0,1-.21-1.89.8.8,0,0,0,0,.15l0-.18a42.36,42.36,0,0,0,1.19-7.51,10.44,10.44,0,0,0-.52-3.8c-1.85-5.3-8.21-7.47-13.84-8.47s-11.93-1.86-15.46-6.26c-1.09-1.36-1.83-3-3.07-4.23a12.19,12.19,0,0,0-5.75-2.84,32.49,32.49,0,0,0-20.92,1.82c-2.72,1.21-5.45,2.85-8.43,2.67s-5.75-2.33-8.81-2.85c-4.94-.84-9.67,2.79-12.1,7.08a17.29,17.29,0,0,0-2.24,8.36c0,.16,0,.33,0,.49h0a12.19,12.19,0,0,0,3.21,8.53c2.13,2.21,5.31,3.73,6.19,6.64.36,1.18.27,2.46.59,3.66,0,.15.09.3.14.44l-.16.21A37.05,37.05,0,0,0,939,238.75a37.9,37.9,0,0,0,26.63,35.94c0,.37,0,.75,0,1.12,0,4.54-1.29,9.17-5.17,12.58L926.8,301.93s-20.29-2.41-27.61,27.25a50.12,50.12,0,0,0-1.26,15.05c.27,4.47-.35,12.35-5.55,22.54-8.33,16.3-6.43,53.72,10.59,57.43,16.07,3.5,22.36,2,23,1.87l0,.65c-.26,7-2.81,67.59-12.08,74.92-2.56,2-2.08,3.4,0,4.32,0,0,0,.39-.06,1.09-.28,4.43-1.71,21.3-7.91,30.9-7.19,11.11-6.44,75.22-6.44,75.22L894.65,651s3,23.34,0,27.42c-2.7,3.63-6.3,90-7,108.71h-.32a9.09,9.09,0,0,0-7.27,4.43c-4,6.46-17.9,18.39-17.9,18.39-3,4.29-14.19,8.39-20.1,10.33a12.19,12.19,0,0,0-2.28,1,12,12,0,0,0-5.07,5.34,5.78,5.78,0,0,0-.55,4.46c1.52,3.7,32.92,6.29,40.86,2.59,6.25-2.92,31-6.75,41.27-8.25a8.49,8.49,0,0,0,7.35-7.34,4.85,4.85,0,0,0-1-3.68v0c-2-2.44-3-9.09-3.43-13.43a8.87,8.87,0,0,0,2.31-1.37,98.53,98.53,0,0,1,5.67-39.64c7.57-20,9.84-57.07,8-81.15,0,0,23.08-99.3,41.24-108.57h0c.28.35,9.09,11.67,10.21,46.68,1.14,35.57,14,58.91,14,58.91s-5.68,60.4,0,83l-7.43,35.66c-.54-.47-.89-.83-.89-.83s.22,1,.53,2.58l-.16.75.32.08c.84,4.46,2.09,12.23,1.58,16.79-.3,2.59-1,6.15-1.52,9.64-.78,5.49-1,10.81,1.89,12,4.73,1.9,32.54,4.5,37.27-1.61a8.78,8.78,0,0,0,1.38-9.16,9.35,9.35,0,0,0-1.38-2.33s-7.38-12.07-5.3-20.58a6.22,6.22,0,0,0-.88-4.89c.32-4.18,2-23.51,6.37-39.93,4.73-17.83,14.72-56.92,7.37-82.63h0c-.28-1-.6-2-.94-3a110.78,110.78,0,0,1-4.16-43.35,88.3,88.3,0,0,1,0-37.8c4.54-20.75,7.71-41.13,7.71-41.13s2.51-27.41.32-44.22l-.15-1.08,1.2-.27s-6.43-28.53-8.7-46.68c-.54-4.29-1.24-9.72-2-15.52a37.61,37.61,0,0,0,6.17-1.53C1059.6,432.72,1066,369,1066,369V348.8S1072.84,317.86,1049,304.15ZM896.8,796.22c-.63-.32-1-.53-1-.53h0Z",
    transform: "translate(-59.52 -31.65)",
    fill: "url(#56fd5fc2-5801-467f-a895-372693779337)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1036.67,671.91c8.86,25.48-1.48,66.83-6.28,85.29s-6.28,40.63-6.28,40.63c-18.83,2.95-32.49-.75-32.49-.75l7.75-38c-5.54-22.52,0-82.71,0-82.71s-12.55-23.26-13.66-58.71c-1.09-34.9-9.69-46.17-10-46.52h0c-17.72,9.23-40.25,108.2-40.25,108.2,1.85,24-.37,60.92-7.75,80.86a100.21,100.21,0,0,0-5.54,39.51c-2.58,2.18-6.17,2.55-10.05,1.93C901.61,799.89,889,790.81,889,790.81S893,683,896,678.93s0-27.33,0-27.33l4.79-37.66s-.73-63.89,6.28-75c6.06-9.57,7.45-26.38,7.72-30.79,0-.7.06-1.09.06-1.09l10.68-12.8s103.4-7.75,111.15,0c1.91,1.91,3.08,6.23,3.78,11.68,2.13,16.75-.31,44.07-.31,44.07s-3.1,20.31-7.53,41a89.59,89.59,0,0,0,0,37.66A112.53,112.53,0,0,0,1036.67,671.91Z",
    transform: "translate(-59.52 -31.65)",
    fill: "#65617d"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1030.21,833.83c-4.62,6.09-31.76,3.5-36.38,1.61-2.82-1.17-2.6-6.47-1.84-11.94.48-3.48,1.19-7,1.48-9.61.74-6.65-2.22-20.13-2.22-20.13s6.1,6.46,7.57,0c.65-2.82,2.92-4.27,5.27-5a13.85,13.85,0,0,1,9.59.6c4.79,2.08,12.8,6.52,11.36,12.52-2,8.48,5.17,20.51,5.17,20.51a9.36,9.36,0,0,1,1.34,2.32A8.88,8.88,0,0,1,1030.21,833.83Z",
    transform: "translate(-59.52 -31.65)",
    fill: "#a27772"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1030.21,833.83c-4.62,6.09-31.76,3.5-36.38,1.61-2.82-1.17-2.6-6.47-1.84-11.94,2.91,1.36,7.87,2.5,16.13,1.73a46.94,46.94,0,0,1,5.81-.18,134.05,134.05,0,0,0,17.62-.35A8.88,8.88,0,0,1,1030.21,833.83Z",
    transform: "translate(-59.52 -31.65)",
    opacity: 0.1
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M935.49,679.3c1.85,24-.37,60.92-7.75,80.86a100.21,100.21,0,0,0-5.54,39.51c-2.58,2.18-6.17,2.55-10.05,1.93C914.38,786,923.87,718.92,930,665.91,936.88,605.54,969.28,564,969.28,564l6.46,7.11C958,580.33,935.49,679.3,935.49,679.3Z",
    transform: "translate(-59.52 -31.65)",
    opacity: 0.1
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1019.13,291.21l-4.51,22.15-22.08,37.11-27.23-11.63s-37-38.77-13.75-44.31a20.39,20.39,0,0,0,7.72-3.44c4.57-3.44,6-8.45,6-13.35,0-8.09-3.78-15.89-3.78-15.89l47.63-15a76.08,76.08,0,0,0-3.42,19.3c-.36,13,4.46,19.36,8.41,22.41A14.44,14.44,0,0,0,1019.13,291.21Z",
    transform: "translate(-59.52 -31.65)",
    fill: "#fbbebe"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1009.16,246.9a76.08,76.08,0,0,0-3.42,19.3,34.91,34.91,0,0,1-2.77,2.94,37.67,37.67,0,0,1-37.66,8.6c0-8.09-3.78-15.89-3.78-15.89Z",
    transform: "translate(-59.52 -31.65)",
    opacity: 0.1
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1014.62,240.81A37.66,37.66,0,1,1,977,203.14,37.5,37.5,0,0,1,1014.62,240.81Z",
    transform: "translate(-59.52 -31.65)",
    fill: "#fbbebe"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1019.13,291.21l-4.51,22.15-22.08,37.11-27.23-11.63s-37-38.77-13.75-44.31a20.39,20.39,0,0,0,7.72-3.44c-4.2,11.55,13.14,35.57,13.14,35.57,2,3,6.65,1.1,6.65,1.1,11.16-1.68,31.73-33.81,35.08-39.15A14.44,14.44,0,0,0,1019.13,291.21Z",
    transform: "translate(-59.52 -31.65)",
    opacity: 0.1
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1040.45,506c-6.55,1.49-42.83,9.53-56.59,7.52-15.13-2.22-44.57-3.69-44.57-3.69s-18.74,1-24.51-1.62c0-.7.06-1.09.06-1.09l10.68-12.8s103.4-7.75,111.15,0C1038.58,496.21,1039.75,500.53,1040.45,506Z",
    transform: "translate(-59.52 -31.65)",
    opacity: 0.1
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M972.42,327.76s-19.48-27-12.14-37.49l-32.91,13.49s-19.81-2.4-27,27.16a51.13,51.13,0,0,0-1.23,15c.26,4.46-.34,12.31-5.42,22.46-8.13,16.25-6.28,53.54,10.34,57.24s22.52,1.84,22.52,1.84-2.21,67.58-11.81,75.33,24.47,5.91,24.47,5.91,29.44,1.48,44.58,3.69,57.6-7.75,57.6-7.75-6.28-28.44-8.49-46.53-7.39-56.62-7.39-56.62l37.67-51s6.64-30.83-16.62-44.49-32-17-32-17S991.25,327,979.07,328.87C979.07,328.87,974.44,330.73,972.42,327.76Z",
    transform: "translate(-59.52 -31.65)",
    fill: "#7c7cdd"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M929.22,338.47s-.37,12.19,1.84,17,10.34,31.39,10.34,31.39H922.94s10-10.71,9.23-15.88S929.22,338.47,929.22,338.47Z",
    transform: "translate(-59.52 -31.65)",
    opacity: 0.1
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M983.87,430.42s-40.78-10-44.58-18.47S925,384.46,925,384.46l4.3-5.8,19.84,15.57s23.63,18.83,34.71,20.68S983.87,430.42,983.87,430.42Z",
    transform: "translate(-59.52 -31.65)",
    fill: "#fbbebe"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M983.87,430.42s-40.78-10-44.58-18.47S925,384.46,925,384.46l4.3-5.8,19.84,15.57s23.63,18.83,34.71,20.68S983.87,430.42,983.87,430.42Z",
    transform: "translate(-59.52 -31.65)",
    opacity: 0.05
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1019.13,382.42v22.12h-3.56a103.54,103.54,0,0,0-50.21,13l-6.66,3.7-1.79,1-11.45-25.78,10.71-9.6.55,0c2.62.25,13.95,1.2,18.75-.42,4.56-1.55,10.22-6.46,23.65-3,6.62,1.69,12.27,9.11,18.69,6.79Z",
    transform: "translate(-59.52 -31.65)",
    fill: "#fbbebe"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1054.76,342.17l7.39,8.3V370.6s-6.28,63.51-26.22,70.53-55.53-4.07-55.53-4.07-9.2-24.37-4.9-25.84,38-10.38,38-10.38-.47-37.26,6.91-48.34c0,0-4.8-34.7,11.82-35.44S1054.76,342.17,1054.76,342.17Z",
    transform: "translate(-59.52 -31.65)",
    opacity: 0.1
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M1055.87,342.17l7.39,8.3V370.6S1057,434.11,1037,441.13s-55.54-4.07-55.54-4.07-9.19-24.37-4.89-25.84,38-10.38,38-10.38-.48-37.26,6.91-48.34c0,0-4.8-34.7,11.82-35.44S1055.87,342.17,1055.87,342.17Z",
    transform: "translate(-59.52 -31.65)",
    fill: "#7c7cdd"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M1004.29,256.81c.15-2.43.2-5-.84-7.19s-3.48-3.94-5.86-3.38c-3.16.74-4.52,4.85-7.62,5.84-2.61.83-5.46-1-6.7-3.46s-1.28-5.3-1.29-8c0-3.08,0-6.17,0-9.25,0-3.36-.11-7-2.18-9.62-2.57-3.29-8.62-4.72-12.66-4.59a10.72,10.72,0,0,0-7.23,2.92c-2.16,1.83-4.66,3.19-7.61,2.7a6.57,6.57,0,0,1-5.3-4.58l0-.12a37.66,37.66,0,1,1,56,50A100.66,100.66,0,0,0,1004.29,256.81Z",
    transform: "translate(-59.52 -31.65)",
    opacity: 0.1
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M952.28,221.64a6.58,6.58,0,0,1-5.3-4.59c-.31-1.19-.23-2.46-.58-3.65-.86-2.9-4-4.41-6-6.61-4.16-4.42-3.89-11.68-.94-17,2.38-4.28,7-7.89,11.81-7.06,3,.52,5.57,2.65,8.6,2.84s5.57-1.45,8.23-2.66a31,31,0,0,1,20.41-1.81,11.87,11.87,0,0,1,5.62,2.83,50,50,0,0,1,3,4.21c3.45,4.39,9.61,5.25,15.1,6.24s11.69,3.16,13.5,8.44c1.19,3.5,0,7.3-.65,10.94a3.16,3.16,0,0,0,.14,2.25c.86,1.42,3,.83,4.62,1.17,3.12.65,3.92,4.66,4,7.84q.2,5.46.3,10.92a10.73,10.73,0,0,1-3.47,9.13l-12.19,14.65c-5.41,6.5-11.15,14.07-10.06,22.45-2.56,1.15-5.6-1.07-6.44-3.75s-.16-5.56.4-8.31a101.72,101.72,0,0,0,1.93-14.42c.15-2.44.2-5-.84-7.19s-3.48-4-5.86-3.39c-3.16.74-4.52,4.85-7.62,5.84-2.6.83-5.46-1-6.7-3.46s-1.28-5.3-1.29-8l0-9.26c0-3.35-.11-7-2.18-9.62-2.57-3.29-8.62-4.72-12.66-4.59a10.74,10.74,0,0,0-7.23,2.92C957.73,220.77,955.23,222.12,952.28,221.64Z",
    transform: "translate(-59.52 -31.65)",
    fill: "#7c5c5c"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M960.79,337.55l11.56,47.5S981.47,385,960.79,337.55Z",
    transform: "translate(-59.52 -31.65)",
    opacity: 0.1
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M1000.3,329.61s-15.14,24.8-9.23,50.43l2.82.21S988.85,368.38,1000.3,329.61Z",
    transform: "translate(-59.52 -31.65)",
    opacity: 0.1
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M1009.9,469.93s18.59-6.15,19.94,8.12C1029.84,478.05,1026.33,468.27,1009.9,469.93Z",
    transform: "translate(-59.52 -31.65)",
    opacity: 0.1
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M956.17,388s-3.69,25.85,3,36.19c0,0-13.52,5.54-32.5,4.43L924.42,388Z",
    transform: "translate(-59.52 -31.65)",
    opacity: 0.1
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M958.7,421.23l-1.79,1-11.45-25.78,10.71-9.6h.55v0C956.55,388.09,953.57,410.29,958.7,421.23Z",
    transform: "translate(-59.52 -31.65)",
    opacity: 0.1
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M956.17,386.85s-3.69,25.84,3,36.18c0,0-13.52,5.54-32.5,4.43l-12.92-40.61Z",
    transform: "translate(-59.52 -31.65)",
    fill: "#7c7cdd"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M924.23,818.11a8.35,8.35,0,0,1-7.17,7.31c-10,1.5-34.18,5.32-40.28,8.22-7.75,3.69-38.4,1.11-39.88-2.58a5.86,5.86,0,0,1,.53-4.44,11.91,11.91,0,0,1,5-5.33,12.27,12.27,0,0,1,2.22-1c5.77-1.93,16.67-6,19.62-10.3,0,0,13.59-11.89,17.46-18.32a8.89,8.89,0,0,1,7.1-4.42c3.24-.15,6.84,1.48,8.31,8.57,0,0,17.72,10.11,22.51,1.24,0,0,.74,13.62,3.68,17.34l0,0A4.94,4.94,0,0,1,924.23,818.11Z",
    transform: "translate(-59.52 -31.65)",
    fill: "#a27772"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M924.23,818.11a8.35,8.35,0,0,1-7.17,7.31c-10,1.5-34.18,5.32-40.28,8.22-7.75,3.69-38.4,1.11-39.88-2.58a5.86,5.86,0,0,1,.53-4.44,11.91,11.91,0,0,1,5-5.33c5,3.32,16.09,6.56,40.49,2.75,23.27-3.63,34.79-7.19,40.41-9.62l0,0A4.94,4.94,0,0,1,924.23,818.11Z",
    transform: "translate(-59.52 -31.65)",
    opacity: 0.1
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1025,214.3l0-.18c.53-2.77,1.32-5.63,1.14-8.39a53.74,53.74,0,0,1-1.14,6.73A4.09,4.09,0,0,0,1025,214.3Z",
    transform: "translate(-59.52 -31.65)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.44,248.86a10.88,10.88,0,0,1,.91,4.22,12.58,12.58,0,0,0-.91-5.88c-1-2.21-3.47-3.95-5.85-3.39-3.16.74-4.52,4.85-7.62,5.84-2.61.83-5.46-1-6.71-3.46s-1.27-5.3-1.28-8c0-3.09,0-6.17,0-9.26,0-3.35-.11-7-2.18-9.62-2.57-3.29-8.63-4.72-12.66-4.59a10.72,10.72,0,0,0-7.23,2.92c-2.17,1.84-4.66,3.19-7.61,2.71a6.58,6.58,0,0,1-5.3-4.59c-.31-1.19-.23-2.46-.58-3.65-.87-2.9-4-4.41-6-6.61a12,12,0,0,1-3.11-7.81,12.58,12.58,0,0,0,3.11,9.47c2.08,2.2,5.17,3.72,6,6.62.35,1.18.27,2.45.58,3.64a6.58,6.58,0,0,0,5.3,4.59c3,.48,5.44-.87,7.61-2.71a10.72,10.72,0,0,1,7.23-2.92c4-.13,10.09,1.31,12.66,4.59,2.07,2.64,2.17,6.27,2.18,9.62,0,3.09,0,6.17,0,9.26,0,2.74,0,5.59,1.28,8s4.1,4.29,6.71,3.46c3.1-1,4.46-5.1,7.62-5.84C1000,244.92,1002.41,246.65,1003.44,248.86Z",
    transform: "translate(-59.52 -31.65)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1033.79,238.69a14.17,14.17,0,0,1-3.14,5.08q-6.09,7.33-12.19,14.65c-5.13,6.17-10.57,13.31-10.17,21.18.37-7.22,5.4-13.79,10.17-19.52l12.19-14.64a14.3,14.3,0,0,0,3.14-5.09,13.74,13.74,0,0,0,.32-4A9.62,9.62,0,0,1,1033.79,238.69Z",
    transform: "translate(-59.52 -31.65)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1002,277.12a8.77,8.77,0,0,1-.36-2,10,10,0,0,0,.36,3.64c.84,2.68,3.89,4.89,6.45,3.74-.07-.54-.11-1.08-.13-1.62C1005.74,281.94,1002.78,279.76,1002,277.12Z",
    transform: "translate(-59.52 -31.65)"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M879.26,795s3.86,6.79,17.84.81",
    transform: "translate(-59.52 -31.65)",
    opacity: 0.1
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M997.5,796.67s12.06,14.2,27.26,4.65",
    transform: "translate(-59.52 -31.65)",
    opacity: 0.1
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M1032.61,628.7s-8.53,5.33-8.8,8.38,4.4-2.22,4.4-2.22Z",
    transform: "translate(-59.52 -31.65)",
    opacity: 0.1
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M1036,669.53a17.81,17.81,0,0,1-10.5,4.1c-6.37.28-5.84,8.59-1.68,6.09S1036,669.53,1036,669.53Z",
    transform: "translate(-59.52 -31.65)",
    opacity: 0.1
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M1037.59,674.86s-4.09,20.1-7.41,16.22",
    transform: "translate(-59.52 -31.65)",
    opacity: 0.1
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M196.28,768.36s5.49,7.18-2.54,18-14.65,20-12,26.76c0,0,12.11-20.14,22-20.42S207.13,780.47,196.28,768.36Z",
    transform: "translate(-59.52 -31.65)",
    fill: "#009ddd"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M196.28,768.36a8.63,8.63,0,0,1,1.12,2.25c9.62,11.3,14.75,21.85,5.5,22.12-8.61.24-19,15.65-21.42,19.54a9.06,9.06,0,0,0,.29.88s12.11-20.14,22-20.42S207.13,780.47,196.28,768.36Z",
    transform: "translate(-59.52 -31.65)",
    opacity: 0.1
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M206.49,777.51c0,2.53-.28,4.58-.63,4.58s-.64-2.05-.64-4.58.36-1.33.71-1.33S206.49,775,206.49,777.51Z",
    transform: "translate(-59.52 -31.65)",
    fill: "#ffd037"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M210,780.53c-2.22,1.21-4.16,1.94-4.33,1.64s1.5-1.54,3.72-2.75,1.34-.33,1.51,0S212.22,779.32,210,780.53Z",
    transform: "translate(-59.52 -31.65)",
    fill: "#ffd037"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M167.26,768.36s-5.49,7.18,2.54,18,14.65,20,12,26.76c0,0-12.11-20.14-22-20.42S156.42,780.47,167.26,768.36Z",
    transform: "translate(-59.52 -31.65)",
    fill: "#009ddd"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M167.26,768.36a9,9,0,0,0-1.12,2.25c-9.62,11.3-14.75,21.85-5.5,22.12,8.62.24,19,15.65,21.42,19.54a7,7,0,0,1-.29.88s-12.11-20.14-22-20.42S156.42,780.47,167.26,768.36Z",
    transform: "translate(-59.52 -31.65)",
    opacity: 0.1
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M157.05,777.51c0,2.53.28,4.58.63,4.58s.64-2.05.64-4.58-.36-1.33-.71-1.33S157.05,775,157.05,777.51Z",
    transform: "translate(-59.52 -31.65)",
    fill: "#ffd037"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M153.55,780.53c2.22,1.21,4.15,1.94,4.32,1.64s-1.5-1.54-3.72-2.75-1.34-.33-1.51,0S151.33,779.32,153.55,780.53Z",
    transform: "translate(-59.52 -31.65)",
    fill: "#ffd037"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M158.8,812.21s15.36-.47,20-3.77,23.62-7.23,24.77-1.94,23.08,26.29,5.74,26.43-40.29-2.7-44.91-5.52S158.8,812.21,158.8,812.21Z",
    transform: "translate(-59.52 -31.65)",
    fill: "#a8a8a8"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M209.61,831.09c-17.34.14-40.29-2.7-44.91-5.52-3.52-2.14-4.92-9.83-5.39-13.38l-.51,0s1,12.39,5.59,15.2,27.57,5.66,44.91,5.52c5,0,6.74-1.82,6.64-4.46C215.25,830.06,213.34,831.06,209.61,831.09Z",
    transform: "translate(-59.52 -31.65)",
    opacity: 0.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.685b5e1daae4a309199cec88dc9a9aff.svg";
export { ForwardRef as ReactComponent };